<template>
  <div>
    <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value
      ])"
      :link="{
        name: $t('sidebar.dashboard'),
        icon: 'tim-icons icon-chart-pie-36',
        path: {name: 'shipper.dashboard'}
      }"
    >
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value,
        permission.INTEGRA_MANAGER__FINANCIER.value,
      ])"
      :link="{
        name: $t('sidebar.control_tower'),
        icon: 'tim-icons icon-chart-bar-32',
      }"
    >
      <sidebar-item
        :link="{
          name: $t('sidebar.kanban'),
          path: {name: 'shipper.control_tower'},
          isRoute: false,
        }" />

      <sidebar-item
        :link="{
          name: $t('sidebar.map'),
          path: {name: 'shipper.order_in_progress'},
          isRoute: false,
        }" />
    </sidebar-item>

    <sidebar-item
      :link="{
            name: $t('sidebar.requests'),
            icon: 'tim-icons icon-basket-simple',
          }"
    >
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value
        ])"
        :material=true
        :link="{
          name: $t('sidebar.request'),
          icon: 'playlist_add_check',
          path: {name: 'shipper.request'},
          isRoute: false,
        }"
      />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value
        ])"
        :material=true
        :link="{
          name: $t('sidebar.road_map'),
          icon: 'map',
          path: {name: 'shipper.road_map'},
          isRoute: false,
        }"
      />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value
        ])"
        :material=true
        :link="{
          name: $t('pages.import_nf.import_nf'),
          path: {name: 'shipper.request_import_nf'},
          isRoute: false,
        }"
      />
    </sidebar-item>

    <sidebar-item
      :link="{
        name: $t('sidebar.expedition'),
        icon: 'tim-icons icon-bag-16',
      }"
      v-if="canSeePicking"
    >
      <sidebar-item
        :link="{
          name: $t('sidebar.box'),
          path: {name: 'shipper.box'},
          isRoute: false,
        }" />
      <sidebar-item
        :link="{
          name: $t('sidebar.products'),
          path: {name: 'shipper.product'},
          isRoute: false,
        }" />
      <sidebar-item
        :link="{
          name: $t('sidebar.picking_kanban'),
          path: {name: 'shipper.picking_control_tower'},
          isRoute: false,
        }" />
      <sidebar-item
        :link="{
          name: $t('sidebar.picking_packing'),
          path: {name: 'shipper.picking'},
          isRoute: false,
        }" />
    </sidebar-item>

    <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value,
        permission.INTEGRA_MANAGER__QUOTATION_APPROVER_USER.value
      ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.ADVANCED.value)"
      :link="{
            name: $t('sidebar.shippings'),
            icon: 'tim-icons icon-coins',
          }"
    >
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value,
        ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PREMIUM.value)"
        :link="{
          name: $t('sidebar.simulation'),
          path: {name: 'shipper.order_simulation'},
          isRoute: false,
      }"/>
      <sidebar-item
        :link="{
          name: this.$t('sidebar.quotes'),
          path: {name: 'shipper.order_quotes'},
          isRoute: false,
        }" />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value,
        ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PREMIUM.value)"
        :link="{
          name: $t('sidebar.approve_table'),
          path: {name: 'shipper.simulation.approve_table'},
          isRoute: false,
      }"/>
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value,
        ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PREMIUM.value)"
        :link="{
          name: $t('sidebar.approve_route_table'),
          path: {name: 'shipper.approve_route_table'},
          isRoute: false,
      }"/>
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value,
        permission.INTEGRA_MANAGER__SHIPPER_COMMERCIAL.value,
        permission.INTEGRA_MANAGER__FINANCIER.value
      ])"
      :link="{
            name: $t('sidebar.orders'),
            icon: 'tim-icons icon-delivery-fast',
          }"
    >
      <sidebar-item
        :link="{
          name:$t('sidebar.all_orders'),
          path: {name: 'shipper.order'},
          isRoute: false,
        }"/>
      <sidebar-item
        :link="{
          name: $t('sidebar.occurrences'),
          path: {name: 'shipper.order_occurrences'},
          isRoute: false,
        }"/>
      <sidebar-item
        :link="{
          name: $t('pages.fob_order.title'),
          path: {name: 'shipper.fob_order'},
          isRoute: false
        }"
      />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value,
        ])"
        :link="{
          name: $t('sidebar.canceled'),
          path:{name: 'shipper.order_canceled'},
          isRoute: false,
        }"/>
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value,
        ])"
        :material="true"
        :link="{
          name: $t('sidebar.address'),
          icon: 'list',
          path: {name: 'shipper.address_alias'}
        }"
      />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value,
        ])"
        :link="{
          name: $t('sidebar.not_imported_files'),
          path: {name: 'shipper.not_imported_files'},
        }"
      />
    </sidebar-item>
<!--    <sidebar-item-->
<!--      v-if="$canAny([-->
<!--        permission.INTEGRA_MANAGER__OWNER.value,-->
<!--        permission.INTEGRA_MANAGER__ADMIN.value,-->
<!--        permission.INTEGRA_MANAGER__FINANCIER.value-->
<!--      ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.ADVANCED.value)"-->
<!--      :link="{-->
<!--            name: $t('sidebar.purchase_order'),-->
<!--            icon: 'tim-icons icon-cart',-->
<!--          }">-->
<!--      <sidebar-item-->
<!--        :link="{-->
<!--            name: $t('sidebar.charts'),-->
<!--            path: {name: 'shipper.purchase_order_board'}-->
<!--          }">-->
<!--      </sidebar-item>-->
<!--      <sidebar-item-->
<!--        :link="{-->
<!--            name: $t('sidebar.add'),-->
<!--            icon: 'tim-icons icon-cart',-->
<!--            path: {name: 'shipper.purchase_order_create'}-->

<!--          }">-->
<!--      </sidebar-item>-->
<!--      <sidebar-item-->
<!--        :link="{-->
<!--            name: $t('sidebar.purchase_order'),-->
<!--            icon: 'tim-icons icon-cart',-->
<!--            path: {name: 'shipper.purchase_order'}-->

<!--          }">-->
<!--      </sidebar-item>-->
<!--      <sidebar-item-->
<!--        :link="{-->
<!--            name: $t('sidebar.import'),-->
<!--            icon: 'tim-icons icon-cloud-upload-94',-->
<!--            path: {name: 'shipper.imports'}-->
<!--          }">-->
<!--      </sidebar-item>-->
<!--      <sidebar-item-->
<!--        :link="{-->
<!--            name: $t('sidebar.purchase_order_exports'),-->
<!--            icon: 'tim-icons icon-notes',-->
<!--            path: {name: 'shipper.purchase_order_exports'}-->
<!--          }">-->
<!--      </sidebar-item>-->
<!--    </sidebar-item>-->
<!--    <sidebar-item-->
<!--      v-if="$canAny([-->
<!--        permission.INTEGRA_MANAGER__OWNER.value,-->
<!--        permission.INTEGRA_MANAGER__ADMIN.value,-->
<!--        permission.BILLING__OWNER.value-->
<!--      ])"-->
<!--      :link="{-->
<!--            name: $t('sidebar.faturas'),-->
<!--            icon: 'tim-icons icon-money-coins',-->
<!--          }">-->
<!--      <sidebar-item-->
<!--        :link="{-->
<!--            name: $t('sidebar.current_billing'),-->
<!--            icon: 'tim-icons icon-shape-star',-->
<!--            path: {name: 'shipper.billing.home'}-->

<!--          }">-->
<!--      </sidebar-item>-->
<!--      <sidebar-item-->
<!--        :link="{-->
<!--            name: $t('sidebar.billing'),-->
<!--            icon: 'tim-icons icon-money-coins',-->
<!--            path: {name: 'shipper.billing'}-->

<!--          }">-->
<!--      </sidebar-item>-->
<!--      <sidebar-item-->
<!--        :link="{-->
<!--            name: $t('sidebar.closing_day'),-->
<!--            icon: 'tim-icons icon-money-coins',-->
<!--            path: {name: 'shipper.billing.closing_day'}-->
<!--          }">-->
<!--      </sidebar-item>-->
<!--    </sidebar-item>-->
    <sidebar-item
      v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value,
          permission.INTEGRA_MANAGER__FINANCIER.value,
          permission.INTEGRA_MANAGER__FINANCIER_BASIC.value,
        ])"
        :material="true"
        :link="{
          name: $t('sidebar.reports'),
          icon: 'list',
        }"
    >
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value
        ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.ADVANCED.value)"
        :link="{
          name: $t('sidebar.list_documents'),
          path: {name: 'shipper.orders_documents'},
          isRoute: false,
        }"/>
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value
        ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.BASIC.value)"
        :link="{
            name: $t('sidebar.orders'),
            icon: 'tim-icons icon-notes',
            path:{name: 'shipper.order_export'},
          }"
        />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value
        ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.BASIC.value)"
        :link="{
            name: $t('sidebar.requests'),
            icon: 'tim-icons icon-notes',
            path:{name: 'shipper.request_export'},
          }"
        />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value,
          permission.INTEGRA_MANAGER__FINANCIER.value,
          permission.INTEGRA_MANAGER__FINANCIER_BASIC.value
        ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PRO.value)"
        :link="{
          name: $t('sidebar.canhoto_check'),
          icon: 'assignment_turned_in',
          path: {name: 'shipper.canhoto'}
        }"
      />
      <sidebar-item
        v-if="$canAny([
          permission.INTEGRA_MANAGER__OWNER.value,
          permission.INTEGRA_MANAGER__ADMIN.value
        ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.PRO.value)"
        :link="{
          name: $t('sidebar.nf_files'),
          icon: 'assignment_turned_in',
          path: {name: 'shipper.nf_files'}
        }"
      />
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value
      ])"
      :link="{
            name: $t('sidebar.exports_imports'),
            icon: 'tim-icons icon-notes',
          }"
    >
      <sidebar-item
        v-if="$hasPlanOrBetter(plans.LOGISTIC_MANAGER.ADVANCED.value)"
        :link="{
          name: $t('sidebar.list_documents'),
          icon: 'tim-icons icon-notes',
          path:{name: 'shipper.orders_documents_export'},
        }"
      />

      <sidebar-item
        v-if="$hasPlanOrBetter(plans.LOGISTIC_MANAGER.BASIC.value)"
        :link="{
          name: $t('sidebar.orders'),
          icon: 'tim-icons icon-notes',
          path:{name: 'shipper.order_reports'},
        }"
      >
      </sidebar-item>
      <sidebar-item
        v-if="$hasPlanOrBetter(plans.LOGISTIC_MANAGER.BASIC.value)"
        :link="{
          name: $t('sidebar.requests'),
          icon: 'tim-icons icon-notes',
          path:{name: 'shipper.request_reports'},
        }"
      >
      </sidebar-item>
      <sidebar-item
        v-if="$hasPlanOrBetter(plans.LOGISTIC_MANAGER.BASIC.value)"
        :link="{
          name: $t('sidebar.occurrences'),
          icon: 'tim-icons icon-notes',
          path:{name: 'shipper.occurrence_reports'},
        }"
      >
      </sidebar-item>
      <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value
      ])"
      :link="{
          name: $t('sidebar.transporters'),
          icon: 'tim-icons icon-notes',
          path:{name: 'shipper.transporters_export'},
        }"
      />
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value
      ])"
      :material=true
      :link="{
            name: $t('sidebar.users_and_companies'),
            icon: 'group',
          }"
    >
      <sidebar-item
        v-if="$hasPlanOrBetter(plans.LOGISTIC_MANAGER.BASIC.value) && user.user.company.parent_id == null"
        :link="{
            name: $t('sidebar.branches'),
            path: {name: 'shipper.subsidiary'},
            isRoute: false
          }"
      />
<!--      <sidebar-item-->
<!--        :material="true"-->
<!--        :link="{-->
<!--            name: $t('sidebar.customers'),-->
<!--            path: {name: 'shipper.customer'},-->
<!--            isRoute: false-->
<!--          }"-->
<!--      />-->
        <sidebar-item
          :material=true
          :link="{
            name: $t('sidebar.users'),
            path: {name: 'shipper.user'},
            isRoute: false
          }"
        />

      <sidebar-item
        :link="{
          name: $t('sidebar.transporters'),
          path: {name: 'shipper.transporter'},
          isRoute: false,
        }"
      />

      <sidebar-item
        :link="{
          name: $t('sidebar.suppliers'),
          path: {name: 'shipper.supplier'},
          isRoute: false,
        }"
      />

      <sidebar-item
        :link="{
          name: $t('sidebar.final_customers'),
          path: {name: 'shipper.final_customer'},
          isRoute: false,
        }"
      />
    </sidebar-item>

    <sidebar-item
      v-if="canSeeSatisfactionSurvey"
      :material="true"
      :link="{
        name: $t('sidebar.satisfaction_survey'),
        icon: 'list',
      }"
    >
      <sidebar-item
        :link="{
          name: $t('sidebar.satisfaction_survey_results'),
          path: {name: 'shipper.satisfaction_survey_results'}
        }"
      />
      <sidebar-item
        :link="{
          name: $t('sidebar.satisfaction_survey_answers'),
          path: {name: 'shipper.satisfaction_survey_answers'}
        }"
      />
    </sidebar-item>

    <sidebar-item
      v-if="$canAny([
        permission.INTEGRA_MANAGER__OWNER.value,
        permission.INTEGRA_MANAGER__ADMIN.value
      ]) && $hasPlanOrBetter(plans.LOGISTIC_MANAGER.BASIC.value)"
      :material=true
      :link="{
            name: $t('sidebar.settings'),
            icon: 'settings',
            path: {name: 'shipper.configuration'}

          }"
    >
    </sidebar-item>
  </div>
</template>

<script>
  import UserPermission from "@/util/valueObjects/userPermission";
  import userRole from "@/util/valueObjects/userRole";
  import cnpjMotorola from "@/util/valueObjects/cnpjMotorola";
  import Plans from "@/util/valueObjects/plans";
  import CompanyFeature from "@/util/valueObjects/companyFeature";
  import * as Cookies from "js-cookie";

  export default {
    name: "sidebar",
    data(){
      return{
        permission: UserPermission,
        role: userRole,
        cnpjMotorola: cnpjMotorola,
        user: Cookies.getJSON("token"),
        plans: Plans,
      }
    },
    computed: {
      canSeeSatisfactionSurvey() {
        return this.$canAny([
          UserPermission.INTEGRA_MANAGER__OWNER.value,
          UserPermission.INTEGRA_MANAGER__ADMIN.value,
          UserPermission.INTEGRA_MANAGER__SHIPPER_COMMERCIAL.value
        ])
        && this.$hasPlanOrBetter(Plans.LOGISTIC_MANAGER.PRO.value)
        && this.$hasFeature(CompanyFeature.FINAL_CUSTOMER_SATISFACTION_SURVEY);
      },
      canSeePicking() {
        return this.$canAny([
          UserPermission.INTEGRA_MANAGER__OWNER.value,
          UserPermission.INTEGRA_MANAGER__ADMIN.value,
        ])
        && this.$hasPlanOrBetter(Plans.LOGISTIC_MANAGER.PRO.value)
        && this.$hasFeature(CompanyFeature.PICKING);
      },
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>
